import style from '../modules/style';

const LETTER_ANCHOR_PREFIX = 'index-';

/**
 * This route handles the Glossary index as well as single terms!
 */
const GlossaryRoute = (path) => {
    const $form = document.getElementById('glossary-search');

    if ($form) {
        const $searchInput = $form.elements.search;
        const $clearButton = document.getElementById('glossary-search-clear');

        const resolveClearButtonVisibility = function() {
            style($clearButton, {
                visibility: $searchInput.value.length ? 'visible' : 'hidden',
            });
        };

        $searchInput.addEventListener('input', resolveClearButtonVisibility);
        resolveClearButtonVisibility();

        $clearButton.addEventListener('click', function(e) {
            // Clear the value:
            $searchInput.value = '';

            // Submit!
            $form.submit();
        });

        // Bind alphabetic keypresses to quick-navigation:
        window.addEventListener('keydown', function(e) {
            // Ignore input when in an actual input element:
            if (document.activeElement instanceof HTMLInputElement || document.activeElement instanceof HTMLTextAreaElement) {
                return;
            }

            // Ignore when modifier keys are pressed:
            if (e.metaKey || e.altKey || e.ctrlKey) {
                return;
            }

            // Ignore non-alphabetic input:
            if (!e.key.match(/^[a-zA-Z]$/g)) {
                return;
            }

            const id = `${LETTER_ANCHOR_PREFIX}${e.key}`;
            const $target = document.getElementById(id);

            // Bail if it didn't match a letter (i.e. there are no terms):
            if (!$target) {
                return;
            }

            window.history.pushState(null, null, `#${id}`);
            $target.focus();
        });
    }
};

export default GlossaryRoute;
